export default __webpack_public_path__ + "static/media/gameOfLife.58c0b280.png";